import { render, staticRenderFns } from "./LoginOidc.vue?vue&type=template&id=dc7ff868"
import script from "./LoginOidc.vue?vue&type=script&lang=js"
export * from "./LoginOidc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports